// Play / Score detail, Apogee: opened by tapping the score, like the
// Puzzle's goal. The words spelled so far with their points. Tapping it
// closes it. It starts closed.
import { scorePlay, type PlayLevel, type PlayState } from '@wits/core';

interface Props {
  level: PlayLevel;
  board: PlayState;
  onClose: () => void;
}

export function ScoreDetail({ level, board, onClose }: Props) {
  const score = scorePlay(level, board.constellations);
  return (
    <div className="panel score-detail" onClick={onClose}>
      {score.words.length === 0 ? (
        <p className="score-detail-empty quiet">Spell a word to see its score here</p>
      ) : (
        <table className="score-detail-table">
          <tbody>
            {score.words.map((w) => (
              <tr key={w.word}>
                <td className="score-detail-word mono">{w.word}</td>
                <td className="score-detail-points mono">{w.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
